/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmZpusobDoruceni extends GContentBase<SeznamAdmZpusobDoruceniObj> {
        private seznamObj: SeznamAdmZpusobDoruceniObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmZpusobDoruceniObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmZpusobDoruceni",
                contentCaption: "jres:33000192", //RC 33000192 : Způsoby doručení
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{zpusob_dor}"
                },
                gridSettings: {
                    columnOrder: "zpusob_dor,zpusob_dor_txt,zmenu_prov_txt,dat_zmena,k_xml,povol_sl"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmZpusobDoruceniObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            if (isNew == true) {
                this.cnt.dialogs.warning("jres:32000149", "jres:33000193") //RC 33000193 : Zakládání nových záznamů je metodicky blokováno.
            } else {
                $.content().navigate(["Gordic.Adm.WebControls.DetailAdmZpusobDoruceni", {
                    currentFilter: this.filterData,
                    gridRc: new Gordic.Components.GridRC(this.grid)
                }], {
                    ID: "DetailAdmZpusobDoruceni",
                    newRecord: isNew,
                    zpusob_dor: data.zpusob_dor
                })
            }
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmZpusobDoruceni.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.zpusob_dor),
                nazev: ""
            }
        }
    }
}